<template>
  <main-template>
    <v-row>
      <v-col>
        <span class="text-h4">Relatórios </span>
        <e-help-tooltip :text="$constants.tooltips.relatorios.verTodos" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h2 class="text-h5 mb-2">{{ escola.descricao }}</h2>
        <e-label>Pesquise uma unidade escolar aqui</e-label>
        <v-autocomplete
          v-model="escola"
          :items="this.franquiasList"
          item-text="descricao"
          item-value="id"
          dense
          return-object
          filled
          label="Pesquise uma escola"
        ></v-autocomplete>
      </v-col>
    </v-row>

    <v-tabs
      v-model="tab"
      grow
      background-color="transparent"
      class="elevation-1 mb-6"
      color="primary"
    >
      <v-tab href="#turmas" class="text-capitalize">
        <v-icon left>groups</v-icon>
        Turmas
      </v-tab>
      <v-tab href="#relatorios" class="text-capitalize">
        <v-icon left>query_stats</v-icon>
        Relatórios
      </v-tab>
      <v-tab href="#documentos" class="text-capitalize">
        <v-icon left>description</v-icon>
        Documentos
      </v-tab>
      <v-tab href="#gestao" class="text-capitalize">
        <v-icon left>manage_accounts</v-icon>
        Gestão
      </v-tab>
      <v-tab href="#notifiq" class="text-capitalize">
        <v-icon left>mdi-bell-ring</v-icon>
        Notifiq
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab" class="mt-4">
      <!-- Turmas -->
      <v-tab-item value="turmas" class="pa-4" style="background-color: #efefef">
        <v-row style="background-color: #efefef">
          <!-- Turmas - Escola atual (sem alunos) -->
          <v-col cols="12" sm="6" md="4" v-if="escola && escola.id">
            <v-card
              color="primary"
              @click="listarTurmasEscola(escola.id)"
              :id="`card-turmas-escola-${escola.id}`"
            >
              <v-card-title>
                <v-icon large left>groups</v-icon>
                <span class="title font-weight-light">Turmas (sem alunos)</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola atual</v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Todas as turmas - Todas as escolas-->
          <v-col cols="12" sm="6" md="4">
            <v-card
              color="primary"
              @click="alunosPorUnidades(escola?.id)"
              :id="`card-todas-turmas`"
            >
              <v-card-title>
                <v-icon large left> groups </v-icon>
                <span class="title font-weight-light">Turmas (com alunos)</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola atual</v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Todas as turmas - Todas as escolas (sem alunos) -->
          <v-col cols="12" sm="6" md="4">
            <v-card color="primary" @click="listarTodasTurmas()" :id="`card-todas-turmas`">
              <v-card-title>
                <v-icon large left>groups</v-icon>
                <span class="title font-weight-light">Todas as turmas (sem alunos)</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Todas as escolas</v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Todas as turmas - Todas as escolas -->
          <v-col cols="12" sm="6" md="4">
            <v-card
              color="primary"
              @click="escolasTurmasAlunos()"
              :id="`card-todas-escolas-turmas`"
            >
              <v-card-title>
                <v-icon large left>groups</v-icon>
                <span class="title font-weight-light">Todas as turmas (com alunos)</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Todas as escolas</v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <v-card color="primary" @click="mapaDeMatriculasPorEscola(escola?.id)">
              <v-card-title>
                <v-icon large left>groups</v-icon>
                <span class="title font-weight-light">Mapa de matrículas</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola Atual</v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="4" v-if="escola && escola.id">
            <v-card
              :id="`aba_turmas.card_gravidez_na_adolecencia_${escola.id}`"
              color="primary"
              @click="alunosGravidezAdolescencia(escola.id)"
            >
              <v-card-title>
                <v-icon large left>groups</v-icon>
                <span class="title font-weight-light">Relatório de Gravidez na Adolescência</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola atual</v-card-text>
            </v-card>
          </v-col>
          <!--  -->
        </v-row>
      </v-tab-item>
      <!-- Fim - Turmas -->

      <!-- Relatórios -->
      <v-tab-item value="relatorios" class="pa-4" style="background-color: #efefef">
        <v-row style="background-color: #efefef">
          <!-- Relatório aulas - Relatório inserção de aulas -->
          <v-col cols="12" sm="6" md="4">
            <v-card color="primary" @click="insercaoAulas()" :id="`card-todas-turmas`">
              <v-card-title>
                <v-icon large left>query_stats</v-icon>
                <span class="title font-weight-light">Relatório aulas</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold"
                >Relatório inserção de aulas</v-card-text
              >
            </v-card>
          </v-col>
          <!--  -->

          <!-- Relatório de faltas - Escola atual -->
          <v-col cols="12" sm="6" md="4">
            <v-card
              color="primary"
              @click="relatoriosEvasao(escola?.id)"
              :id="`card-relatorio-faltas`"
            >
              <v-card-title>
                <v-icon large left>query_stats</v-icon>
                <span class="title font-weight-light">Relatório de Faltas</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola Atual</v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Relatório de Faltas (Professores) -->
          <v-col cols="12" sm="6" md="4" v-if="escola && escola.id">
            <v-card color="primary" @click="OpenModalProfessor()" :id="`card-faltas-professores`">
              <v-card-title>
                <v-icon large left>query_stats</v-icon>
                <span class="title font-weight-light">Relatório de Faltas</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold"
                >(Professores) - Escola Atual</v-card-text
              >
            </v-card>
          </v-col>
          <!--  -->

          <!-- Relatório de Transferências -->
          <v-col cols="12" sm="6" md="4">
            <v-card
              color="primary"
              @click="relatorioDeTransferencias()"
              :id="`card-transferencias`"
            >
              <v-card-title>
                <v-icon large left>query_stats</v-icon>
                <span class="title font-weight-light">Relatório de Transferências</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola atual</v-card-text>
            </v-card>
          </v-col>

          <!-- Todas as turmas - Todas as escolas (sem alunos) -->
          <v-col cols="12" sm="6" md="4">
            <v-card
              color="primary"
              @click="alunosPCDPorUnidades(escola?.id)"
              :id="`card-todas-turmas`"
            >
              <v-card-title>
                <v-icon large left>groups</v-icon>
                <span class="title font-weight-light">Relatório de Alunos (PCD)</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola atual</v-card-text>
            </v-card>
          </v-col>

          <!--  -->

          <v-col cols="12" sm="6" md="4">
            <v-dialog v-model="modalSelecaoMesUsoDoSistema" width="500">
              <template v-slot:activator="{ on, attrs }">
                <!-- @click="relatoriosUsoDoSistema(mes, escola.id)" -->
                <v-card
                  v-bind="attrs"
                  v-on="on"
                  color="primary"
                  :id="`card-relatorios-uso-do-sistema-${escola.id}`"
                >
                  <template slot="progress">
                    <v-progress-linear color="primary" height="5" indeterminate></v-progress-linear>
                  </template>
                  <v-card-title>
                    <v-icon large left> mdi-account-search </v-icon>
                    <span class="title font-weight-light">Relatório de Uso do Sistema</span>
                  </v-card-title>
                  <v-card-text class="subtitle font-weight-bold"> Todas as escolas </v-card-text>
                </v-card>
                <!-- <v-btn color="red lighten-2" dark v-bind="attrs" v-on="on"> Click Me </v-btn> -->
              </template>

              <v-card>
                <v-card-title class="text-h5 grey primary d-flex justify-center">
                  Escolha o mês do relatório</v-card-title
                >

                <v-card-text class="text-center mt-6">
                  <v-btn-toggle
                    v-model="mesUsoDoSistema"
                    v-for="mes in $constants.meses"
                    :key="mes.id"
                  >
                    <v-btn @click="relatoriosUsoDoSistema(mes.id, escola.id)" :value="mes">
                      {{ mes.descricao }}
                      <!-- <v-icon>mdi-format-align-left</v-icon> -->
                    </v-btn>
                  </v-btn-toggle>
                </v-card-text>

                <v-divider></v-divider>
                <v-card-actions class="d-flex justify-end">
                  <v-btn text color="primary" @click="modalSelecaoMesUsoDoSistema = false">
                    Fechar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
      </v-tab-item>

      <v-tab-item value="notifiq" class="pa-4" style="background-color: #efefef">
        <v-row style="background-color: #efefef">
          <v-col cols="12" sm="6" md="4" v-if="escola && escola.id">
            <v-card color="primary" @click="abrirDialogFaltantesNotifiq">
              <v-card-title>
                <v-icon large left>mdi-account-alert-outline</v-icon>
                <span class="title font-weight-light">Alunos sem Presença</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola atual</v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4" v-if="escola && escola.id">
            <v-card color="primary" @click="abrirDialogNotifiq" :id="`card-presencas-notifiq`">
              <v-card-title>
                <v-icon large left>mdi-bell-ring</v-icon>
                <span class="title font-weight-light">Presenças</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola atual</v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4" v-if="escola && escola.id">
            <v-card
              color="primary"
              @click="alunosMatriculadosNotifiq(escola.id)"
              :id="`card-alunos-notifiq`"
            >
              <v-card-title>
                <v-icon large left>mdi-account-group</v-icon>
                <span class="title font-weight-light">Alunos por Turma</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola atual</v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-dialog v-model="dialogNotifiq" max-width="520">
          <v-card>
            <v-card-title class="text-h6 primary white--text">
              Relatório de Presenças Notifiq
            </v-card-title>
            <v-card-text class="pt-6">
              <v-menu
                v-model="dialogDataInicio"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="notifiqForm.dataInicio"
                    label="Data inicial"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="notifiqForm.dataInicio"
                  locale="pt-br"
                  @input="dialogDataInicio = false"
                />
              </v-menu>

              <v-menu
                v-model="dialogDataFim"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="notifiqForm.dataFim"
                    label="Data final"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="notifiqForm.dataFim"
                  locale="pt-br"
                  @input="dialogDataFim = false"
                />
              </v-menu>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn text @click="dialogNotifiq = false">Cancelar</v-btn>
              <v-btn
                color="primary"
                :disabled="!notifiqIntervaloSelecionado"
                @click="presencasNotifiq(escola.id)"
              >
                Gerar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-tab-item>
      <!-- Fim - Notifiq -->

      <!-- Documentos -->
      <v-tab-item value="documentos" class="pa-4" style="background-color: #efefef">
        <v-row style="background-color: #efefef">
          <!-- Boletins - Escola atual -->
          <v-col cols="12" sm="6" md="4">
            <v-card
              color="primary"
              @click="boletinsFranquia(escola.id)"
              :id="`card-boletins-escola-${escola.id}`"
            >
              <v-card-title>
                <v-icon large left>receipt_long</v-icon>
                <span class="title font-weight-light">Boletins</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola atual</v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Relatórios Semestral BNCC - Escola atual -->
          <v-col cols="12" sm="6" md="4">
            <v-card
              color="primary"
              @click="relatoriosSemestralBnccFranquia(escola.id)"
              :id="`card-relatorios-bncc-escola-${escola.id}`"
            >
              <v-card-title>
                <v-icon large left>child_care</v-icon>
                <span class="title font-weight-light">Relatórios Semestral BNCC</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola atual</v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Relatórios BNCC - Escola atual -->
          <v-col cols="12" sm="6" md="4" v-if="anoPermitido">
            <v-card
              color="primary"
              @click="relatoriosBnccFranquia(escola.id)"
              :id="`card-relatorios-bncc-escola-${escola.id}`"
            >
              <v-card-title>
                <v-icon large left>child_care</v-icon>
                <span class="title font-weight-light">Relatórios Bimestral BNCC</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola atual</v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Relatório de planos lançados - Escola atual -->
          <v-col cols="12" sm="6" md="4" v-if="escola && escola.id">
            <v-card
              color="primary"
              @click="relatorioDeListagemDosPlanosLancados(escola.id)"
              :id="`card-planos-lancados-escola-${escola.id}`"
            >
              <v-card-title>
                <v-icon large left>auto_stories</v-icon>
                <span class="title font-weight-light">Relatório de planos lançados</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola Atual</v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Relatório de planos lançados - Todas as escolas -->
          <v-col cols="12" sm="6" md="4" v-if="escola && escola.id">
            <v-card
              color="primary"
              @click="relatorioDeListagemDosPlanosLancadosGeral(escola.id)"
              :id="`card-planos-lancados-geral`"
            >
              <v-card-title>
                <v-icon large left>auto_stories</v-icon>
                <span class="title font-weight-light">Relatório de planos lançados</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Todas as escolas</v-card-text>
            </v-card>
          </v-col>
          <!--  -->
        </v-row>
      </v-tab-item>
      <!-- Fim - Documentos -->

      <!-- Gestão -->
      <v-tab-item value="gestao" class="pa-4" style="background-color: #efefef">
        <v-row style="background-color: #efefef">
          <!-- Relatório de lotação - Escola atual -->
          <v-col cols="12" sm="6" md="4">
            <v-card color="primary" @click="lotacaoEscola(escola?.id)">
              <v-card-title>
                <v-icon large left> mdi-book-variant </v-icon>
                <span class="title font-weight-light">Relatório de lotação</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold"> Escola Atual </v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Relatório de lotação - Todas as escolas -->
          <v-col cols="12" sm="6" md="4">
            <v-card color="primary" @click="lotacaoGeral()">
              <v-card-title>
                <v-icon large left> mdi-book-variant </v-icon>
                <span class="title font-weight-light">Relatório de lotação</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold"> Todas as escolas </v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Relatório de lotação por escola - Todas as escolas -->
          <v-col cols="12" sm="6" md="4">
            <v-card color="primary" @click="lotacao()">
              <v-card-title>
                <v-icon large left> mdi-book-variant </v-icon>
                <span class="title font-weight-light">Relatório de lotação por escola</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold"> Todas as escolas </v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Relatório Por escola (Censo) - Escola atual -->
          <v-col cols="12" sm="6" md="4">
            <v-card
              color="primary"
              @click="relatoriosCensoFranquia(escola?.id)"
              :id="`card-relatorios-censo-escola-${escola.id}`"
            >
              <template slot="progress">
                <v-progress-linear color="primary" height="5" indeterminate></v-progress-linear>
              </template>
              <v-card-title>
                <v-icon large left> mdi-book-variant </v-icon>
                <span class="title font-weight-light">Relatório Por escola (Censo)</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold"> Escola atual </v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Professores por disciplina - Todas as escolas -->
          <v-col cols="12" sm="6" md="4">
            <v-card
              color="primary"
              @click="qtdProfessoresPorDisciplina()"
              :id="`card-professores-por-disciplina`"
            >
              <template slot="progress">
                <v-progress-linear color="primary" height="5" indeterminate></v-progress-linear>
              </template>
              <v-card-title>
                <v-icon large left> manage_accounts </v-icon>
                <span class="title font-weight-light">Professores por componente curricular</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Todas as escolas</v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Alunos não matriculados - Escola atual -->
          <v-col cols="12" sm="6" md="4">
            <v-card
              color="primary"
              @click="alunosNaoMatriculados(escola?.id)"
              :id="`card-alunos-nao-matriculados-escola-${escola.id}`"
            >
              <v-card-title>
                <v-icon large left> manage_accounts </v-icon>
                <span class="title font-weight-light">Alunos não matriculados</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola Atual</v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Alunos não matriculados - Todas as escolas -->
          <v-col cols="12" sm="6" md="4">
            <v-card
              color="primary"
              @click="alunosNaoMatriculadosGeral()"
              :id="`card-alunos-nao-matriculados-geral`"
            >
              <v-card-title>
                <v-icon large left> manage_accounts </v-icon>
                <span class="title font-weight-light">Alunos não matriculados</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Todas as escolas</v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Resumo movimento escolar - Escola atual -->
          <v-col cols="12" sm="6" md="4">
            <v-card
              color="primary"
              @click="resumoMovimentoEscolar(escola?.id)"
              :id="`card-resumo-movimento-escolar-escola-${escola.id}`"
            >
              <v-card-title>
                <v-icon large left> manage_accounts </v-icon>
                <span class="title font-weight-light">Resumo movimento escolar</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold"> Escola atual</v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Relatório de Alunos (PCD) - Escola atual -->
          <v-col cols="12" sm="6" md="4">
            <v-card
              color="primary"
              @click="alunosPCDPorUnidades(escola?.id)"
              :id="`card-todas-turmas`"
            >
              <v-card-title>
                <v-icon large left>groups</v-icon>
                <span class="title font-weight-light">Relatório de Alunos (PCD)</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola atual</v-card-text>
            </v-card>
          </v-col>
          <!--  -->
        </v-row>
      </v-tab-item>
      <!-- Fim - Gestão -->
    </v-tabs-items>

    <!--  -->

    <v-row>
      <template v-if="dialog">
        <v-row justify="center">
          <v-dialog v-model="dialog" max-width="450">
            <v-card>
              <v-card-title class="text-h5"> Selecione o mês correspondente </v-card-title>

              <v-card-text>
                <v-row justify="center" class="mt-4">
                  <v-date-picker v-model="picker" type="month"></v-date-picker>
                </v-row>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn color="green darken-1" text @click="relatoriosEvasaoProfessor(escola.id)"
                  >Gerar Relatório</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
    </v-row>

    <template v-if="dialogTransferencias">
      <v-row justify="center">
        <v-dialog v-model="dialogTransferencias" max-width="600">
          <v-card>
            <v-card-title class="text-h5">Relatório de Transferências</v-card-title>

            <v-card-text>
              <v-radio-group v-model="tipoRelatorio" column>
                <v-radio
                  label="Gerar relatório de toda a unidade escolar"
                  value="franquia"
                ></v-radio>
                <v-radio label="Selecionar turmas específicas" value="turmas"></v-radio>
              </v-radio-group>

              <v-autocomplete
                v-if="tipoRelatorio === 'turmas'"
                v-model="turmasSelecionadas"
                :items="turmasList"
                item-text="descricao"
                item-value="id"
                chips
                multiple
                clearable
                deletable-chips
                label="Selecione as turmas"
                hint="Você pode selecionar uma ou mais turmas"
                persistent-hint
                :loading="carregandoTurmas"
                return-object
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip
                    v-if="index < 3"
                    :key="item.id"
                    color="primary"
                    small
                    close
                    @click:close="removeTurma(item)"
                  >
                    <span>{{ item.descricao }}</span>
                  </v-chip>
                  <span v-if="index === 3" class="grey--text text-caption">
                    (+{{ turmasSelecionadas.length - 3 }} outras)
                  </span>
                </template>
              </v-autocomplete>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="grey" text @click="dialogTransferencias = false"> Cancelar </v-btn>
              <v-btn
                color="success"
                @click="gerarRelatorioTransferencias()"
                :disabled="
                  tipoRelatorio === 'turmas' &&
                  (!turmasSelecionadas || turmasSelecionadas.length === 0)
                "
              >
                Gerar Relatório
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <template v-if="dialogFaltantesNotifiq">
      <v-row justify="center">
        <v-dialog v-model="dialogFaltantesNotifiq" max-width="450">
          <v-card>
            <v-card-title class="text-h5">Alunos sem Presença - Notifiq</v-card-title>

            <v-card-text>
              <v-row justify="center" class="mt-4">
                <v-date-picker v-model="dataFaltantesNotifiq"></v-date-picker>
              </v-row>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="grey" text @click="dialogFaltantesNotifiq = false">Cancelar</v-btn>
              <v-btn color="green darken-1" text @click="gerarFaltantesNotifiq">
                Gerar Relatório
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <e-modal-boletim-franquia
      :dialog="dialogBoletimFranquia"
      :franquia_id="franquia_id"
      @dialogChange="dialogBoletimFranquia = $event"
    ></e-modal-boletim-franquia>
    <e-modal-bncc-franquia
      :dialog="dialogBnccFranquia"
      :franquia_id="franquia_id"
      @dialogChange="dialogBnccFranquia = $event"
    ></e-modal-bncc-franquia>
  </main-template>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Relatórios",
  data() {
    return {
      dialog: false,
      tab: null, // Controle da aba ativa
      picker: "",
      escola: {
        descricao: null,
        id: null,
      },
      dialogBoletimFranquia: false,
      franquia_id: null,
      dialogTransferencias: false,
      tipoRelatorio: "franquia",
      turmasSelecionadas: [],
      turmasList: [],
      carregandoTurmas: false,
      modalSelecaoMesUsoDoSistema: false,
      mesUsoDoSistema: null,
      mesSelecionadoUsoDoSistema: new Date().toISOString().substr(0, 7),
      dialogBnccFranquia: false,
      dialogNotifiq: false,
      dialogDataInicio: false,
      dialogDataFim: false,
      notifiqForm: {
        dataInicio: "",
        dataFim: "",
      },
      dialogPresencasNotifiq: false,
      tipoPresencasNotifiq: "escola",
      periodoPresencasNotifiq: [
        new Date().toISOString().substr(0, 10),
        new Date().toISOString().substr(0, 10),
      ],
      dialogFaltantesNotifiq: false,
      dataFaltantesNotifiq: new Date().toISOString().substr(0, 10),
    };
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
    ...mapGetters("Franquias", ["franquiasList", "carregandoFranquias"]),
    anoPermitido() {
      return new Date().getFullYear() <= 2025;
    },
    notifiqIntervaloSelecionado() {
      return Boolean(this.notifiqForm.dataInicio && this.notifiqForm.dataFim);
    },
  },
  methods: {
    abrirDialogFaltantesNotifiq() {
      this.dataFaltantesNotifiq = new Date().toISOString().substr(0, 10);
      this.dialogFaltantesNotifiq = true;
    },
    async gerarFaltantesNotifiq() {
      this.dialogFaltantesNotifiq = false;
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.faltantesNotifiq(
          parseInt(this.escola.id, 10),
          this.dataFaltantesNotifiq
        );
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    abrirDialogNotifiq() {
      this.dialogNotifiq = true;
    },

    async alunosPorUnidades(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.alunosPorUnidadeEScolar(parseInt(franquia_id, 10));
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async alunosPCDPorUnidades(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.alunosPCDPorUnidadeEScolar(
          parseInt(franquia_id, 10)
        );
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async lotacaoGeral() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.lotacaoGeral();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async lotacao() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.lotacao();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async lotacaoEscola(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.lotacaoEscola(parseInt(franquia_id, 10));
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async boletinsFranquia(franquia_id) {
      try {
        this.franquia_id = franquia_id;
        this.dialogBoletimFranquia = !this.dialogBoletimFranquia;
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },

    async relatoriosBnccFranquia(franquia_id) {
      try {
        this.franquia_id = franquia_id;
        this.dialogBnccFranquia = !this.dialogBnccFranquia;
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async relatoriosSemestralBnccFranquia(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.relatoriosSemestralBnccFranquia(
          parseInt(franquia_id, 10)
        );
      } catch (error) {
        this.$toast.danger("Não encontramos turmas de infantil vinculado a essa escola!");
        // this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async inscritosCongresso() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.inscritosCongresso();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async escolasTurmasAlunos() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.escolasTurmasAlunos();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async listarTodasTurmas() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.listarTodasTurmas();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async listarTurmasEscola(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.listarTurmasFranquia(parseInt(franquia_id, 10));
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async mapaDeMatriculasPorEscola(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.mapaDeMatriculasPorEscola(parseInt(franquia_id, 10));
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async insercaoAulas() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.insercaoAulas();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async resumoMovimentoEscolar(fraquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.resumoMovimentoEscolar(fraquia_id);
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async relatorioDeListagemDosPlanosLancados(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.relatorioDeListagemDosPlanosLancados(
          parseInt(franquia_id, 10)
        );
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async relatorioDeListagemDosPlanosLancadosGeral() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.relatorioDeListagemDosPlanosLancadosGeral();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async relatoriosEvasao(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.relatoriosEvasao(parseInt(franquia_id, 10));
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async presencasNotifiq(franquia_id) {
      if (!this.notifiqForm.dataInicio || !this.notifiqForm.dataFim) {
        this.$toast.danger("Selecione a data início e a data fim.");
        return;
      }

      if (this.notifiqForm.dataFim < this.notifiqForm.dataInicio) {
        this.$toast.danger("A data fim não pode ser menor que a data início.");
        return;
      }

      this.dialogNotifiq = false;

      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.presencasNotifiq(
          parseInt(franquia_id, 10),
          this.notifiqForm.dataInicio,
          this.notifiqForm.dataFim
        );
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async alunosMatriculadosNotifiq(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.alunosMatriculadosNotifiq(parseInt(franquia_id, 10));
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    OpenModalProfessor() {
      this.dialog = true;
    },
    async relatoriosEvasaoProfessor(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        const picker = this.picker;

        if (!picker) {
          this.$toast.danger("Selecione um mês para gerar o relatório");
          this.$loaderService.close();
          return;
        }
        const dataSemTraco = picker.replace(/-/g, "");
        await this.$services.relatoriosService.relatoriosEvasaoProfessor(
          parseInt(franquia_id, 10),
          dataSemTraco
        );
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async alunosNaoMatriculados(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.alunosNaoMatriculados(parseInt(franquia_id, 10));
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async alunosNaoMatriculadosGeral() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.alunosNaoMatriculadosGeral();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async qtdProfessoresPorDisciplina() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.qtdProfessoresPorDisciplina();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async relatoriosCensoFranquia(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.relatoriosCensoFranquia(parseInt(franquia_id, 10));
      } catch (error) {
        this.$toast.danger("Não foi possível carregar a informação solicitada! Tente novamente!");
      }
      this.$loaderService.close();
    },
    async relatorioDeTransferencias() {
      try {
        this.tipoRelatorio = "franquia";
        this.turmasSelecionadas = [];

        await this.carregarTurmasFranquia();

        this.dialogTransferencias = true;
      } catch (error) {
        $handleError(error);

        this.$handleError(error);
      }
    },
    async carregarTurmasFranquia() {
      try {
        this.carregandoTurmas = true;
        const response = await this.$services.turmasService.buscarTurmasPorFranquia(this.escola.id);
        this.turmasList = response || [];
      } catch (error) {
        $handleError(error);
        this.$toast.danger("Erro ao carregar turmas da unidade escolar!");
      } finally {
        this.carregandoTurmas = false;
      }
    },
    async gerarRelatorioTransferencias() {
      try {
        this.$loaderService.open("Gerando relatório...");

        let response;
        if (this.tipoRelatorio === "franquia") {
          response = await this.$services.relatoriosService.relatorioTransferenciasFranquia(
            this.escola.id
          );
        } else {
          const turmasIds = this.turmasSelecionadas.map((turma) => turma.id);
          response = await this.$services.relatoriosService.relatorioTransferencias(turmasIds);
        }
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    removeTurma(item) {
      const index = this.turmasSelecionadas.indexOf(item);
      if (index >= 0) {
        this.turmasSelecionadas.splice(index, 1);
      }
    },
    async relatoriosUsoDoSistema(mes, franquia_id) {
      this.modalSelecaoMesUsoDoSistema = false;
      this.mesUsoDoSistema = null;
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.relatoriosUsoDoSistema(
          mes,
          parseInt(franquia_id, 10)
        );
      } catch (error) {
        this.$toast.danger("Você não tem permissão para acessar esse Recurso.");
      }
      this.$loaderService.close();
    },
    async alunosGravidezAdolescencia(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.alunosGravidezAdolescencia(
          parseInt(franquia_id, 10)
        );
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
  },
  mounted() {
    this.$loaderService.open("Carregando dados...");
    this.escola = this.user.franquia;
    this.$loaderService.close();
  },
};
</script>

<style scoped>
.v-card {
  height: 100%;
  transition: all 0.8s cubic-bezier(0.25, 0.8, 0.25, 1);
  border-radius: 8px !important;
  overflow: hidden;
  border-left: 4px solid transparent;
}

.v-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1), 0 6px 6px rgba(0, 0, 0, 0.08) !important;
}

.v-card.primary {
  border-left-color: var(--v-primary-base);
  background: linear-gradient(to right, #fff7e4, #ffffff);
}

.v-card.success {
  border-left-color: var(--v-success-base);
  background: linear-gradient(to right, #f0fff0, #ffffff);
}

.v-tabs {
  border-radius: 8px;
}

.v-tab {
  font-weight: 500;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
}

.v-tab--active {
  font-weight: 600;
  background-color: rgba(255, 255, 255, 0.062);
}

.v-tab-item {
  padding: 8px 0;
}

.v-col {
  padding-bottom: 16px;
  padding-top: 8px;
}

@media (max-width: 960px) {
  .v-card__title {
    font-size: 1rem !important;
    padding: 12px !important;
  }

  .v-card__text {
    font-size: 0.875rem !important;
    padding: 0 12px 12px !important;
  }

  .v-tab {
    font-size: 0.75rem;
    min-width: auto;
    padding: 0 12px;
  }

  .v-tab .v-icon {
    font-size: 1.25rem !important;
    margin-right: 4px !important;
  }
}

.v-card:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: currentColor;
  opacity: 0;
  transition: opacity 0.3s;
}

.v-card:hover:before {
  opacity: 0.04;
}

.v-autocomplete {
  border-radius: 8px;
  overflow: hidden;
}

.v-row:not(:last-child) {
  margin-bottom: 16px;
}
</style>
